import { Base } from '@studiometa/js-toolkit';
import { toggleClass } from '@studiometa/js-toolkit/utils';
import Menu from './Menu.js';
import LocalizationMenu from './LocalizationMenu.js';

/**
 * Header component
 */
export default class Header extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Header',
    components: {
      Menu,
      LocalizationMenu,
    },
  };

  /**
   * Close all open menus when clicking an anchor link.
   */
  mounted() {
    this.__onAnchorClick = (event) => {
      const anchor = event.target.closest('a[href*="#"]');
      if (!anchor) return;

      const url = new URL(anchor.href, window.location.origin);
      if (url.pathname === window.location.pathname && url.hash) {
        event.preventDefault();

        const hasOpenMenu = this.$children.Menu.some((menu) => menu.isOpen);

        this.$children.Menu.forEach((menu) => {
          if (menu.isOpen) {
            menu.close();
          }
        });

        const scrollToTarget = () => {
          const id = decodeURIComponent(url.hash.slice(1));
          const target = document.querySelector(`#${id}`);
          if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
            history.pushState(null, '', url.hash);
          }
        };

        if (hasOpenMenu) {
          setTimeout(scrollToTarget, 350);
        } else {
          scrollToTarget();
        }
      }
    };

    this.$el.addEventListener('click', this.__onAnchorClick);
  }

  /**
   * Remove anchor click listener.
   */
  destroyed() {
    this.$el.removeEventListener('click', this.__onAnchorClick);
  }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   * @param {object} props.direction For both axis, whether or not the current position has changed since the last one.
   */
  scrolled({ y, direction }) {
    const isOnTop = y <= 0;
    const isNearTop = y < 128;

    toggleClass(document.documentElement, 'is-on-top', isOnTop);
    toggleClass(document.documentElement, 'is-near-top', isNearTop);

    if (direction.y === 'NONE') {
      return;
    }

    toggleClass(document.documentElement, 'is-scrolling-down', direction.y === 'DOWN');
    toggleClass(document.documentElement, 'is-scrolling-up', direction.y === 'UP');
  }

  /**
   *
   */
  onMenuOpen() {
    const openedMenus = this.$children.Menu.filter(({ isOpen }) => isOpen);
    toggleClass(document.documentElement, 'is-menu-open', openedMenus.length > 0);
  }

  /**
   *
   */
  onMenuClose() {
    const openedMenus = this.$children.Menu.filter(({ isOpen }) => isOpen);
    toggleClass(document.documentElement, 'is-menu-open', openedMenus.length > 0);
  }
}
